import Vue from 'vue';
import vuetify from './plugins/vuetify';
import App from './App.vue';
import VTooltip from 'v-tooltip';
import Snotify from 'vue-snotify';
import VueRouter from 'vue-router';

Vue.use(VTooltip, {
    defaultBoundariesElement: '.v-application--wrap',
});
Vue.config.productionTip = false;

Vue.use(Snotify);
Vue.use(VueRouter);

Vue.mixin({
  mounted() {
    if (this.$options.name === 'v-tooltip') {
      this.scrollTimeout = null;

      this.closeOnScroll = (e) => {
        // alter v-tooltip to handle scroll from clearing tooltip.
        if (!this.isActive) return;

        if (this.scrollTimeout) clearTimeout(this.scrollTimeout);
        
        this.scrollTimeout = setTimeout(() => {
          this.isActive = false;
        }, 150);
      };

      // Listen to scroll events in the capture phase
      window.addEventListener('scroll', this.closeOnScroll, true);
    }
  },

  beforeDestroy() {
    if (this.$options.name === 'v-tooltip' && this.closeOnScroll) {
      window.removeEventListener('scroll', this.closeOnScroll, true);
      
      if (this.scrollTimeout)
        clearTimeout(this.scrollTimeout);
    }
  }
});

const routes = [
    //define routes here.
]

const router = new VueRouter({
    routes
})

new Vue({
    vuetify: vuetify.instance,
    render: h => h(App),
    router
}).$mount('#app');
